import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import propTypes from 'prop-types';
import { portalTarget } from './react-portals';

var PortalTargetDefault = /*#__PURE__*/function (_PureComponent) {
  _inherits(PortalTargetDefault, _PureComponent);

  var _super = _createSuper(PortalTargetDefault);

  function PortalTargetDefault() {
    _classCallCheck(this, PortalTargetDefault);

    return _super.apply(this, arguments);
  }

  _createClass(PortalTargetDefault, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, this.props.children);
    }
  }]);

  return PortalTargetDefault;
}(PureComponent);

var PortalTarget = /*#__PURE__*/function (_PureComponent2) {
  _inherits(PortalTarget, _PureComponent2);

  var _super2 = _createSuper(PortalTarget);

  function PortalTarget(props) {
    var _this;

    _classCallCheck(this, PortalTarget);

    _this = _super2.call(this, props);
    _this.Target = portalTarget(props.name)(props.children || PortalTargetDefault);
    return _this;
  }

  _createClass(PortalTarget, [{
    key: "render",
    value: function render() {
      var Target = this.Target;
      return /*#__PURE__*/React.createElement(Target, null);
    }
  }]);

  return PortalTarget;
}(PureComponent);

_defineProperty(PortalTarget, "propTypes", {
  /**
   * name of the portal, used as a unique identifier
   */
  name: propTypes.string
});

export default PortalTarget;